import Modal from '../components/modal';

class ModalPopup {
	constructor(el) {
		this.el = el;

		this.initializeModals();
	}

	initializeModals = () => {
		const btnModalDefault = this.el;

		if (btnModalDefault) {
			btnModalDefault.addEventListener('click', (e) => {
				const dataModal = e.currentTarget.getAttribute('data-modal');
				const modalContent = document.querySelector('.'+dataModal).innerHTML;
				Modal.show(
					modalContent,
					dataModal
				);
			});
		}
	};
}

export default ModalPopup;
